__turbopack_context__.v({
  "card": "EngagementModelsSection-module-scss-module__vHUArq__card",
  "container": "EngagementModelsSection-module-scss-module__vHUArq__container",
  "fade-in-left": "EngagementModelsSection-module-scss-module__vHUArq__fade-in-left",
  "fade-in-right": "EngagementModelsSection-module-scss-module__vHUArq__fade-in-right",
  "grid": "EngagementModelsSection-module-scss-module__vHUArq__grid",
  "root": "EngagementModelsSection-module-scss-module__vHUArq__root",
  "visibleLeft": "EngagementModelsSection-module-scss-module__vHUArq__visibleLeft",
  "visibleRight": "EngagementModelsSection-module-scss-module__vHUArq__visibleRight",
});
